import styled from "styled-components";
import { Icon } from "../styled-icon";
import { ColorAddiBackgroundWhite, ColorAddiCompThreeLighten1 } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontXxSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightSemiBold } from '@addi/foundation/dist/web/fonts';
export const TheNewHeaderContainer = styled.div `
    display: flex;
    flex-direction: row;
    width: 100%; 
    height: 70px;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: ${ColorAddiBackgroundWhite};
    border-radius: 0 0 10px 10px;
`;
export const TheNewHeaderHeaderPaySafeContainer = styled.div `
    position: absolute;
    left: 0;
    color: ${ColorAddiCompThreeLighten1};
    font-size: ${SizeAddiFontXxSmall};
    font-weight: ${FontAddiWeightSemiBold};
    letter-spacing: 0;
    line-height: 28px;

    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 6px;

    ${Icon} {
        margin-right: 5px;
    }
`;
export const TheNewHeaderExitButtonContainer = styled.div `
    position: absolute;
    right: 0;
    width: 42px;
    height: 42px;
`;
//# sourceMappingURL=TheNewHeader.Styled.js.map